import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {AskExpertProfessionalComponent} from '../ask-expert-professional/ask-expert-professional.component';
import {PaiuLeadComponent} from './paiu-lead.component';

const routes: Routes = [
    {
        path: 'paiu-lead',
        component: PaiuLeadComponent,
        data: {animation: 'paiu-lead'}
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PaiuLeadRoutingModule { }
